import { request } from "../request";

import { ModuleItemType } from "@packages/flow-core/module";

export interface IPluginFlow {
  id?: string;
  name: string;
  description?: string;
  modules: ModuleItemType[];
  createdBy?: string;
  createdGmt?: string;
  modifiedBy?: string;
  modifiedGmt?: string;
  rootModuleId?: string;
}

/**
 * 保存子流程
 * @param data
 * @returns
 */
export function savePluginFlowService(data: IPluginFlow) {
  return request<API.BaseResponse<void>>(
    "/api/insnail-flow-platform/damselfish/plugin/management",
    {
      method: "POST",
      data,
    }
  );
}

/**
 * 运行子流程调试
 * @param pluginId
 * @param data
 * @returns
 */
export function runPluginFlowAppService(
  pluginId: number | string,
  data: Record<string, any>
) {
  return request(
    `/api/insnail-flow-platform/damselfish/plugin/runtime/test/${pluginId}`,
    {
      method: "POST",
      data,
      responseType: "stream",
    }
  );
}

/**
 * 获取子流程数据
 * @param pluginId
 * @returns
 */
export function getPluginFlowService(pluginId: string | number) {
  return request<API.BaseResponse<IPluginFlow>>(
    `/api/insnail-flow-platform/damselfish/plugin/management/${pluginId}`
  );
}

/**
 * 清除子流程会话记录
 * @param chatId
 * @returns
 */
export function clearPluginHistoryService(chatId: string) {
  return request<API.BaseResponse>(
    `/api/insnail-flow-platform/damselfish/plugin/runtime/test/clear-chat/${chatId}`,
    {
      method: "PUT",
    }
  );
}

/**
 * 获取插件列表
 * @param data
 * @returns
 */
export function getPluginListService(
  data: Partial<{ name: string; current: number; size: number }>
) {
  return request<
    API.BaseResponse<{
      records: IPluginFlow[];
      total: number;
      size: number;
      current: number;
      pages: number;
      success: boolean;
    }>
  >("/api/insnail-flow-platform/damselfish/plugin/management/list", {
    method: "POST",
    data,
  });
}
